// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ProductOfferingRecentChangesQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  versionId: Types.Scalars['ID']['input'];
}>;


export type ProductOfferingRecentChangesQuery = { __typename?: 'Query', productOffering: { __typename?: 'ProductOffering', id: string, planPackageVersion: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string }, interiorDesignPackageVersion: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string }, exteriorDesignPackageVersion: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string } } };

export type ProductOfferingRecentChanges_ProductOfferingFragment = { __typename?: 'ProductOffering', id: string, project?:
    | { __typename?: 'StandaloneProject', id: string }
    | { __typename?: 'Region', id: string }
    | { __typename?: 'Market', id: string }
    | { __typename?: 'Community', id: string }
    | { __typename?: 'Subdivision', id: string }
    | { __typename?: 'Lot', id: string }
    | { __typename?: 'Structure', id: string }
    | { __typename?: 'Unit', id: string }
   | null | undefined, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string, createdAt: Types.Scalars['DateTime']['input'] }, aggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined }>, planPackageVersion: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string, versionNotes?: string | null | undefined }, interiorDesignPackageVersion: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string, versionNotes?: string | null | undefined }, exteriorDesignPackageVersion: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string, versionNotes?: string | null | undefined } };

export type ProductOfferingRecentChanges_ReadyPlanAggregateVersionFragment = { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string, versionNotes?: string | null | undefined };

export const ProductOfferingRecentChanges_ReadyPlanAggregateVersionFragmentDoc = gql`
    fragment ProductOfferingRecentChanges_ReadyPlanAggregateVersion on ReadyPlanAggregateVersion {
  id
  displayVersion
  versionNotes
}
    `;
export const ProductOfferingRecentChanges_ProductOfferingFragmentDoc = gql`
    fragment ProductOfferingRecentChanges_ProductOffering on ProductOffering {
  id
  project {
    id
  }
  aggregateLatest {
    id
    createdAt
  }
  aggregateVersions {
    id
    version
  }
  planPackageVersion {
    ...ProductOfferingRecentChanges_ReadyPlanAggregateVersion
  }
  interiorDesignPackageVersion {
    ...ProductOfferingRecentChanges_ReadyPlanAggregateVersion
  }
  exteriorDesignPackageVersion {
    ...ProductOfferingRecentChanges_ReadyPlanAggregateVersion
  }
}
    ${ProductOfferingRecentChanges_ReadyPlanAggregateVersionFragmentDoc}`;
export const ProductOfferingRecentChangesDocument = gql`
    query ProductOfferingRecentChanges($id: ID!, $versionId: ID!) {
  productOffering(id: $id, versionId: $versionId) {
    id
    planPackageVersion {
      id
      displayVersion
    }
    interiorDesignPackageVersion {
      id
      displayVersion
    }
    exteriorDesignPackageVersion {
      id
      displayVersion
    }
  }
}
    `;

/**
 * __useProductOfferingRecentChangesQuery__
 *
 * To run a query within a React component, call `useProductOfferingRecentChangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductOfferingRecentChangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductOfferingRecentChangesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useProductOfferingRecentChangesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProductOfferingRecentChangesQuery, ProductOfferingRecentChangesQueryVariables> & ({ variables: ProductOfferingRecentChangesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductOfferingRecentChangesQuery, ProductOfferingRecentChangesQueryVariables>(ProductOfferingRecentChangesDocument, options);
      }
export function useProductOfferingRecentChangesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductOfferingRecentChangesQuery, ProductOfferingRecentChangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductOfferingRecentChangesQuery, ProductOfferingRecentChangesQueryVariables>(ProductOfferingRecentChangesDocument, options);
        }
// @ts-ignore
export function useProductOfferingRecentChangesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingRecentChangesQuery, ProductOfferingRecentChangesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductOfferingRecentChangesQuery, ProductOfferingRecentChangesQueryVariables>;
export function useProductOfferingRecentChangesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingRecentChangesQuery, ProductOfferingRecentChangesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductOfferingRecentChangesQuery | undefined, ProductOfferingRecentChangesQueryVariables>;
export function useProductOfferingRecentChangesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingRecentChangesQuery, ProductOfferingRecentChangesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProductOfferingRecentChangesQuery, ProductOfferingRecentChangesQueryVariables>(ProductOfferingRecentChangesDocument, options);
        }
export type ProductOfferingRecentChangesQueryHookResult = ReturnType<typeof useProductOfferingRecentChangesQuery>;
export type ProductOfferingRecentChangesLazyQueryHookResult = ReturnType<typeof useProductOfferingRecentChangesLazyQuery>;
export type ProductOfferingRecentChangesSuspenseQueryHookResult = ReturnType<typeof useProductOfferingRecentChangesSuspenseQuery>;
export type ProductOfferingRecentChangesQueryResult = ApolloReactCommon.QueryResult<ProductOfferingRecentChangesQuery, ProductOfferingRecentChangesQueryVariables>;